import React from 'react';
import { ProdurctSearchResult } from '../../components/Model/ProdurctSearchResult';

import ResultItem from './ResultItem';
import ResultRedirect from '../../Basepage/parts/ResultRedirect';

interface ResultItemContainerProp {
  domainPrefix: string;
  items: ProdurctSearchResult[];
  itemsCount: number;
}

export default class ResultItemContainer extends React.Component<ResultItemContainerProp> {
  render() {
    let styleInjection: React.CSSProperties = {};

    if (this.props.items.length < 4) {
      styleInjection.justifyContent = 'unset';
    }

    return (
      <div id="itemContainer" style={styleInjection}>
        {this.props.itemsCount == 1 && this.props.items.length == 1 ? (
          <ResultRedirect
            itemLink={'/product_info/' + this.props.items[0].products_id}
          />
        ) : null}
        {this.props.items.map((item, index) => {
          return (
            <ResultItem
              item={item}
              domainPrefix={this.props.domainPrefix}
              key={'ResultItem' + index}
            ></ResultItem>
          );
        })}
      </div>
    );
  }
}
